export default __webpack_public_path__ + "static/media/ebloc4.c90a5031.png";